import script from "./Leiloeiro.vue?vue&type=script&setup=true&lang=js"
export * from "./Leiloeiro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QToggle,QVideo});
